/* eslint-disable react/require-default-props */
import { Stack, Typography } from '@mui/material';
import SelectableCard from 'components/SelectableCard/SelectableCard';
import DisabledModeTooltip from 'components/shared/DisabeldModeToolTip';
import { Method, SCIMMethod } from 'consts';
import React from 'react';
import { TOnClick } from 'types/props';
import { IIdP } from 'types/api';
import IdPIcon from 'components/shared/IdPIcon';
import { CARD_HEIGHT, CARD_PX, CARD_WIDTH } from './IdPCard';

interface IIdPMethodCardProps<T = Method | SCIMMethod> {
	idp: IIdP;
	onClick?: TOnClick;
	selectedIdP: string | null;
	selectedMethod: T | null;
	method: T;
	disabled?: boolean;
}

const IdPMethodCard: React.FC<IIdPMethodCardProps> = ({
	idp,
	onClick = undefined,
	selectedIdP,
	selectedMethod,
	method,
	disabled
}) => {
	const selected = idp.id === selectedIdP && selectedMethod === method;
	return (
		<DisabledModeTooltip
			disabled={!selected && !!disabled}
			title={intl.tr('general.guide.disabledTooltip')}
		>
			<SelectableCard
				data-testid={`custom-idp-method-${method}`}
				sx={{ width: CARD_WIDTH, height: CARD_HEIGHT }}
				onClick={onClick}
				disabled={!selected && disabled}
				selected={selected}
			>
				<Stack
					height="100%"
					direction="row"
					px={CARD_PX}
					alignItems="center"
					gap={1}
				>
					<IdPIcon idp={idp} />
					<Typography variant="subtitle1">
						{intl.tr('ssoConfig.guide.selectIdP.custom.methodLabel', {
							method
						})}
					</Typography>
				</Stack>
			</SelectableCard>
		</DisabledModeTooltip>
	);
};

export default IdPMethodCard;
